import globalStyle from './global-style';
import colors from './colors';
import borders from './borders';
import shadows from './shadows';

const constants = {
  columns: { mobile: 4, tablet: 12, desktop: 12 },
  gridGutter: { mobile: 12, tablet: 12, desktop: 12 },
  // side menu width
  // header height
  // ...
  layout: {
    header: {
      height: '102px',
      progressHeight: '80px',
    },
    footer: {
      desktopTabletHeight: '200px',
      mobileHeight: '162px',
    },
    side: {
      top: {
        mobile: '4%',
        tablet: '4%',
        desktop: '92px',
      },
      leftPadding: {
        mobile: '4%',
        tablet: '4%',
        desktop: '8%',
      },
    },
    calculateHeight(type) {
      switch (type) {
        case 'tabletWithProgressBar':
          return (
            Number(this.header.progressHeight.slice(0, -2)) +
            Number(this.footer.desktopTabletHeight.slice(0, -2)) +
            'px'
          );
        case 'mobileWithProgressBar':
          return (
            Number(this.header.progressHeight.slice(0, -2)) +
            Number(this.footer.mobileHeight.slice(0, -2)) +
            'px'
          );
        case 'tabletWithoutProgresBar':
          return this.footer.desktopTabletHeight;
        case 'mobileWithoutProgressBar':
          return this.footer.mobileHeight;
        default:
      }
    },
    calculateMargin(type) {
      switch (type) {
        case 'progressBar':
          return (
            Number(this.header.progressHeight.slice(0, -2)) +
            Number(spacings[7].slice(0, -2)) -
            130 +
            'px'
          );
        case 'noProgressBar':
          return Number(this.header.height.slice(0, -2)) - 54 + 'px';
        case 'progressBarMobile':
          return (
            Number(this.header.progressHeight.slice(0, -2)) +
            Number(spacings[5].slice(0, -2)) -
            130 +
            'px'
          );
        case 'noProgressBarMobile':
          return Number(this.header.height.slice(0, -2)) - 78 + 'px';
        default:
      }
    },
  },
};

export const spacings = {
  0: '0px',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '24px',
  6: '32px',
  7: '48px',
  8: '64px',
  9: '80px',
  10: '96px',
  11: '120px',
};

export const screensWidth = {
  mobileXS: 374,
  mobile: 580,
  tablet: 949,
  desktop: 1442,
};

export const maxWidths = {
  desktop: '1560px',
};

export const media = {
  mobileXS: `@media (max-width: ${screensWidth.mobileXS}px)`,
  mobile: `@media (max-width: ${screensWidth.mobile}px)`,
  tablet: `@media (max-width: ${screensWidth.tablet}px)`,
  desktop: `@media (max-width: ${screensWidth.desktop}px)`,
};

export const breakpoints = {
  mobileXS: `${screensWidth.mobileXS}px`,
  mobile: `${screensWidth.mobile}px`,
  tablet: `${screensWidth.tablet}px`,
  desktop: `${screensWidth.desktop}px`,
};

const theme = {
  name: 'default', // for storybook
  colors,
  spacings,
  screensWidth,
  media,
  breakpoints,
  constants,
  borders,
  shadows,
  maxWidths,
};

export { globalStyle };
export default theme;
